import React, { useState, useEffect } from "react";
import { Row, Col, Table, Card, CardTitle, CardBody, Button } from "reactstrap";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Form,
  FormGroup,
} from "reactstrap";
import { useLocation } from "react-router-dom";
function Timing() {
  const location = useLocation();
  const { id } = location.state;
  const init = {
    places: "",
    to: "",
    from: "",
  };
  const [timing, setTiming] = useState({
    places: "",
    to: "",
    from: "",
  });
  const [editId, setEditID] = useState("");
  const handleChange = (e) => {
    console.log(e);
    const { name, value } = e.target;
    setTiming((prevFormData) => ({ ...prevFormData, [name]: value }));
    console.log(name, value);
    console.log(timing);
  };
  const saveTiming = async () => {
    const timePattern = /^(0?[1-9]|1[0-2]):[0-5][0-9] (AM|PM)$/;
    // setTiming(init);

    if (timing.to == "") {
      alert("Enter a Time To");
      return;
    }
    if (!timePattern.test(timing.from)) {
      alert("Enter a Time from in Correct Format With Capital AM or PM");
      return;
    }
    if (!timePattern.test(timing.to)) {
      alert("Enter a Time to in Correct Format With Capital AM or PM");
      return;
    }
    if (timing.from == "") {
      alert("Enter a Time from");
      return;
    }
    console.log(timing);

    //fetch("https://tdcp.gop.pk/apis/add_tour?name=&image=&days=&address=&phone=&terminal=&cityId=4")
    //https://tdcp.gop.pk/apis/add_route?places=&routeId=&time_from=&time_to=
    await fetch(
      "https://tdcp.gop.pk/apis/add_route?places=" +
        timing.places +
        "&routeId=" +
        id +
        "&time_from=" +
        timing.from +
        "&time_to=" +
        timing.to
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === 200) {
          alert("Added Succesfully");
          setTiming(init);
          setModal(!modal);
          get();
        } else {
          alert(data.message);
        }
      });
  };
  const deleteTiming = (id) => {
    console.log(id);
    if (window.confirm("All Tours Will be also Deleted?")) {
      // console.log(id);
      //    https://tdcp.gop.pk/apis/update_route?method=delete&id=17
      fetch(" https://tdcp.gop.pk/apis/update_route?method=delete&id=" + id)
        .then((res) => res.json())
        .then((data) => {
          // console.log(data);
          data.status === 200
            ? alert("Deleted Succesfully")
            : alert(data.message);
        });
      //alert("Deleted Succesfully");
      get();
      setTiming(init);
    }
  };
  const editTiming = (id, places, time_to, time_from) => {
    console.log(id, time_to, time_from);
    let update = {
      places: places,
      to: time_to,
      from: time_from,
    };
    console.log(update);
    setTiming((st) => ({
      ...st,
      ...update,
    }));
    console.log(timing.from);
    setEditID(id);
    setModal(!modal);
  };
  const updateTiming = () => {
    console.log(editId);
    if (editId) {
      // https://tdcp.gop.pk/apis/update_route?method=update&id=&places=&time_from=&time_to=
      fetch(
        "https://tdcp.gop.pk/apis/update_route?method=update&id=" +
          editId +
          "&places=" +
          timing.places +
          "&time_from=" +
          timing.from +
          "&time_to=" +
          timing.to
      )
        .then((res) => res.json())
        .then((data) => {
          // console.log(data);
          data.status === 200
            ? alert("Updated Succesfully")
            : alert(data.message);
        });
      // alert("Updated Succesfully");
      setModal(!modal);
      setTiming(init);
      setEditID("");
      get();
    } else {
      alert("Click on Add Button");
    }
  };

  console.log(id + " Id is");
  const [row, setRow] = useState([]);
  const [modal, setModal] = useState(false);
  const [unmountOnClose, setUnmountOnClose] = useState(true);
  const toggle = () => {
    setTiming(init);
    setModal(!modal);
  };
  const changeUnmountOnClose = (e) => {
    let { value } = e.target;
    setUnmountOnClose(JSON.parse(value));
  };

  const get = async () => {
    // fetch('https://fakestoreapi.com/products')

    await fetch(" https://tdcp.gop.pk/apis/get_timings?routeId=" + id)
      .then((res) => res.json())
      .then((data) => setRow(data.data));
  };
  useEffect(() => {
    get();
    console.log("Total Data is");
    console.log(row);
  }, [id]);
  return (
    <div>
      <Row>
        <Col lg="12">
          <Card>
            <CardTitle tag="h6" className="border-bottom p-3 mb-0">
              <i className="bi bi-card-text me-2"> </i>
              Routes Detail
            </CardTitle>
            <CardBody className="">
              <div className="button-group">
                <Button color="danger" onClick={toggle}>
                  Add New Route
                </Button>
              </div>
              <Table bordered hover>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    // row.map((r)=>r.timings.map((t)=>console.log(t)))
                  }
                  {row.map((route) => {
                    return (
                      <tr key={route.time_id}>
                        <td>{route.time_id}</td>
                        <td>{route.places}</td>
                        <td>{route.time_from}</td>
                        <td>{route.time_to}</td>

                        <td>
                          <div className="button-group">
                            <Button
                              color="danger bi-pencil-square"
                              onClick={(e) =>
                                editTiming(
                                  route.time_id,
                                  route.places,
                                  route.time_to,
                                  route.time_from
                                )
                              }
                            ></Button>
                            <Button
                              color="danger bi-trash"
                              onClick={(e) => deleteTiming(route.time_id)}
                            ></Button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Modal isOpen={modal} toggle={toggle} unmountOnClose={unmountOnClose}>
        <ModalHeader toggle={toggle}>Add Route</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="exampleEmail">Places</Label>
              <Input
                id="exampleEmail"
                name="places"
                placeholder="Places Separated by Comma"
                type="text"
                value={timing.places}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="exampleEmail">Time From</Label>
              <Input
                id="exampleEmail"
                name="from"
                value={timing.from}
                placeholder="Time From HH:MM"
                type="text"
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="exampleEmail">Time To</Label>
              <Input
                id="exampleEmail"
                name="to"
                value={timing.to}
                placeholder="Time To HH:MM"
                type="text"
                onChange={handleChange}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={saveTiming}>
            Add Route
          </Button>{" "}
          <Button color="danger" onClick={updateTiming}>
            Update
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default Timing;
